<template>
  <v-tooltip bottom :disabled="!tooltip">
    <template v-slot:activator="{ on, attrs }">
      <small
        class="quality-rating"
        :class="[quality || 'UNKNOWN', { 'cursor-pointer': clickable }]"
        v-bind="attrs"
        v-on="on"
        @click="emitClick"
      >
        {{ size !== "small" ? "Qualidade" : "" }}
        <span class="quality">
          {{ (quality || "UNKNOWN") | whatsappSenderQuality }}
        </span>
      </small>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    quality: {
      type: String,
      default: null,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
  },
  methods: {
    emitClick() {
      if (this.clickable) this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.quality-rating {
  border: 1px solid;
  border-radius: 4px;
  font-weight: 500;
  padding: 4px 4px;
  white-space: nowrap;
  max-width: fit-content;

  .quality {
    text-transform: capitalize;
  }

  &.HIGH,
  &.GREEN {
    background-color: #ebf5f1;
    border-color: #b6d1c6;
    color: #247058;
  }

  &.LOW,
  &.RED {
    background-color: #fff0f1;
    border-color: #facfd4;
    color: #ab1628;
  }

  &.MEDIUM,
  &.YELLOW {
    background-color: #fff8e3;
    border-color: #ffe299;
    color: #ad7410;
  }

  &.UNKNOWN {
    background-color: #e5e5e3;
    border-color: #a6a5a2;
    color: #545452;
  }
}
</style>
